export const StoreBadges = () => (
  <div className="flex flex-wrap items-start gap-4 sm:gap-6" aria-label="App availability">
    <div className="flex flex-col items-center gap-2" data-testid="google-play-status">
      <a
        href="https://play.google.com/store/apps/details?id=com.mocktp.app"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get MockTP on Google Play"
      >
        <img
          src="/store-badges/get-it-on-google-play-badge-en.svg"
          alt="Get it on Google Play"
          className="h-10 min-[375px]:h-12 sm:h-14 xl:h-16 w-auto max-w-full"
        />
      </a>
    </div>
    <div className="flex flex-col items-center gap-2" data-testid="app-store-status">
      <img
        src="/store-badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
        alt="Download on the App Store"
        className="h-10 min-[375px]:h-12 sm:h-14 xl:h-16 w-auto max-w-full opacity-70"
      />
      <span className="text-xs sm:text-sm text-slate-300">Coming soon</span>
    </div>
  </div>
);
